




















































import { Component, Vue } from 'vue-property-decorator'
import CourseItem from './course_item.vue'
import { queryProduct } from '@/api/product/product'
import Product from '@/model/product/product'
import MainBanner from '@/apps/ice/pages/home/components/components/MainBanner.vue'
import { requestHotArticles } from '@/apps/ice/api/jsons'
import { queryBanner } from '@/api/common/constant'
import Banner from '@/model/common/banner'
import { CourseProduct } from '@/model/product/courseProduct'

@Component({
  components: {
    MainBanner,
    CourseItem
  }
})
export default class PageRight extends Vue {
  productList: Product[] = []
  private hotArticles: any[] = []
  public bannerList: Banner[] = []

  async mounted() {
    this.bannerList = await queryBanner(true)
    this.productList = (await queryProduct('HOT')) || []
    this.hotArticles = await requestHotArticles()
  }

  private toPostDetail(id: string) {
    window.open(`https://www.youkeda.com/post/detail/${id}`)
  }

  get dataList() {
    if (this.productList && this.productList.length > 2) {
      return this.productList.splice(0, 2)
    } else {
      return this.productList || []
    }
  }

  private toDetail(product: CourseProduct) {
    window.open(
      `${window.location.origin}/home_m/coursedetail?courseid=${product.id}&courseType=${product.courseType}`
    )
  }
}
